import CmsEntryBaseQuery from '@/graphql/cms/CmsEntryBaseQuery.gql';
import { stripLocale } from '@/utils/i18n';

const whitelistedRoutes = [
  'returns',
  'account',
  'processing',
  'cart',
  'fonts',
  'debug',
  'search',
  'index',
  'knowledge-index-topic-articles', // article overview has different cms calls
];

export default defineNuxtRouteMiddleware(async (to) => {
  // some pages are not available in craft, so we skip the check for them
  if (whitelistedRoutes.some((routePrefix) => to.name.startsWith(routePrefix))) {
    return;
  }

  const { $craftRequest, $getCurrentLocaleConfig } = useNuxtApp();
  const localeConfig = $getCurrentLocaleConfig();
  if (!localeConfig) return;

  const { altCode: locale } = localeConfig;
  const uri = stripLocale(to.path, locale);

  try {
    const { entryCount, entry } = await $craftRequest(CmsEntryBaseQuery, {
      uri,
      site: locale,
    });

    if (entryCount === 0) {
      return abortNavigation();
    }

    if (entry?.useMinimalLayout) {
      to.meta.layout = 'minimal';
    }
  } catch (error) {
    return abortNavigation();
  }
});
